module.exports = __webpack_public_path__ + "e4d489eaf2782437fb07a84b76c1ab19.svg";